import '../styles/main.scss';

import { graphql } from 'gatsby';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { Module } from '../components/ModulesContent';
import { HeroType } from '../components/ui/Hero';
import ItemGridModule from '../components/ui/modules/ItemGridModule';
import { ALL_LANGS } from '../constants';
import { LocalizedSEO } from '../graphql-fragments/seo';
import { withI18n } from '../utils/hocs';
import { getAreasOfExpertiseAsBlocks } from '../utils/projectUtils';
import { localize } from '../utils/sanity';
import PageTemplate from './PageTemplate';

export const query = graphql`
  query GetAreaOfExpertisePageById($id: String!) {
    sanityAreaOfExpertise(_id: { eq: $id }) {
      ...AreaOfExpertise
    }
    allSanityAreaOfExpertise(sort: { orderRank: ASC }) {
      nodes {
        ...AreaOfExpertise
      }
    }
  }
`;

export interface AreaOfExpertise {
  _id: string;
  title: string;
  slug: {
    current: string;
  };
  hero: HeroType;
  description: string;
  modules?: Array<Module>;
  hideFormModule?: boolean;
  seo?: LocalizedSEO;
}

interface LocalizedQueryData {
  sanityAreaOfExpertise: AreaOfExpertise;
  allSanityAreaOfExpertise: {
    nodes: Array<AreaOfExpertise>;
  };
}

const AreaOfExpertisePage = ({ data }): React.ReactElement => {
  const { i18n, t } = useTranslation();

  const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
  const localizedData: LocalizedQueryData = localize(data, langs);

  const { _id, title, hero, description } = localizedData.sanityAreaOfExpertise;

  const otherAreasOfExpertise = localizedData.allSanityAreaOfExpertise.nodes.filter(
    areaOfExpertise => areaOfExpertise._id !== _id,
  );

  const areasOfExpertiseAsGridItems = getAreasOfExpertiseAsBlocks(otherAreasOfExpertise);

  return (
    <PageTemplate
      page={localizedData.sanityAreaOfExpertise}
      description={description}
      defaultSEO={{
        defaultDescription: description,
        defaultTitle: title,
        defaultImageUrl: hero.desktopBackgroundImage?.asset.url,
      }}
      hardCodedModules={
        areasOfExpertiseAsGridItems.length > 0 && (
          <ItemGridModule
            title={t('areaOfExpertise_page.other_areas', 'Outras áreas de atuação')}
            items={areasOfExpertiseAsGridItems}
          />
        )
      }
    />
  );
};

export default withI18n(AreaOfExpertisePage);
